module.exports = __webpack_public_path__ + "static/media/search-down-arrow.cd205f72.svg";